module.exports = __webpack_public_path__ + "static/img/nals-2.98597ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/nals/nals-2.jpg
// module id = Q270
// module chunks = 0